// LooksMyPostsPage.js

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';

import { useAuth } from '../contexts/AuthContext';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import { getPostsByUserId } from '../utils/dbUtilities';
import LooksPost from './LooksPost';

import './MyPostsPage.css';           // ✅ you can reuse the same CSS

const LooksMyPostsPage = () => {
  const { currentUser }            = useAuth();
  const { deletePostById }         = useContext(LooksPostsContext);
  const [myPosts, setMyPosts]      = useState([]);
  const [topMargin, setTopMargin]  = useState('40px');
  const observerRef                = useRef(null);
  const postsRefs                  = useRef({});
  const navigate                   = useNavigate();

  /* ─────────── fetch user’s Looks posts ─────────── */
  useEffect(() => {
    (async () => {
      if (!currentUser) return;

      const userPosts = await getPostsByUserId(currentUser.uid, 'looksPosts');
      const active    = userPosts.filter(p => !p.deleted);

      // convert Firestore Timestamp ➜ Date, then sort newest-first
      const sorted    = active
        .map(p => ({ ...p, timestamp: p.timestamp?.toDate?.() || new Date(p.timestamp) }))
        .sort((a, b) => b.timestamp - a.timestamp);

      setMyPosts(sorted);
    })();
  }, [currentUser]);

  /* ─────────── helpers ─────────── */
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this post?')) return;
    await deletePostById(id);
    setMyPosts(cur => cur.filter(p => p.id !== id));
  };

  /* ─────────── intersection observer (optional) ─────────── */
  useEffect(() => {
    observerRef.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log('Post visible:', entry.target.id);
        }
      });
    }, { threshold: 0.1 });

    return () => observerRef.current?.disconnect();
  }, []);

  useEffect(() => {
    myPosts.forEach(post => {
      const el = document.getElementById(post.id);
      if (el) {
        postsRefs.current[post.id] = el;
        observerRef.current?.observe(el);
      }
    });
    return () => {
      Object.values(postsRefs.current).forEach(el => observerRef.current?.unobserve(el));
    };
  }, [myPosts]);

  /* ─────────── responsive top margin (same as Clips) ─────────── */
  useEffect(() => {
    const update = () => {
      if (window.innerWidth === 1264)      setTopMargin('140px');
      else if (window.innerWidth <= 768)   setTopMargin('200px');
      else                                 setTopMargin('120px');
    };
    window.addEventListener('resize', update);
    update();
    return () => window.removeEventListener('resize', update);
  }, []);

  /* ─────────── render ─────────── */
  return (
    <div className="my-posts-container" style={{ marginTop: topMargin }}>
      <h1 style={{ textAlign: 'center' }}>
        <FaUser /> My Posts
      </h1>

      {myPosts.length
        ? myPosts.map(post => (
            <div key={post.id} className="post-container" id={post.id}>
              <LooksPost {...post} onDelete={() => handleDelete(post.id)} />
            </div>
          ))
        : <p style={{ textAlign: 'center' }}>You don’t have any posts.</p>}
    </div>
  );
};

export default LooksMyPostsPage;
